import { AuthLayout } from "../../../components/layout/auth-layout/auth-layout.tsx";
import { ForgotPasswordForm } from "../../../components/features/auth/forms/forgot-password-form.tsx";
import { useSqeLabs } from "../../../hooks/use-sqe-labs.ts";
import { SQE_AUTH_LAYOUT_PROPS } from "../login-page/sqe-auth-layout.tsx";
import styles from "../login-page/login-page.module.css"; // Reuse login page styles

export default function ForgotPasswordPage() {
  const isSqeLabs = useSqeLabs();
  return (
    <div className={styles.page}>
      <AuthLayout
        {...(isSqeLabs ? SQE_AUTH_LAYOUT_PROPS : {})}
        title="Reset your password"
        subtitle="Enter your email to receive a verification code."
      >
        <ForgotPasswordForm emailPlaceholder={isSqeLabs ? "you@sqelabs.com" : "you@caeliusconsulting.com"} />
      </AuthLayout>
    </div>
  );
}
